import { useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Kbd = ({ children }) => (
  <kbd className="px-1.5 py-0.5 text-[10px] font-mono font-semibold bg-foreground/10 border border-foreground/20 rounded shadow-sm text-foreground/70">
    {children}
  </kbd>
);

const Hint = ({ shortcut, label }) => (
  <span className="inline-flex items-center gap-1.5">
    <Kbd>{shortcut}</Kbd>
    <span className="text-[11px] font-medium text-foreground/50">{label}</span>
  </span>
);

const COMMON_HINTS = [
  { shortcut: '/', label: 'Quick Open' },
  { shortcut: 'H', label: 'Home' },
  { shortcut: 'Esc', label: 'Back' },
  { shortcut: '?', label: 'Help' },
];

const PAGE_HINTS = {
  '/': [
    { shortcut: '1-0', label: 'Open module' },
  ],
  '/income': [
    { shortcut: 'N', label: 'New' },
    { shortcut: 'D+1-7', label: 'Date range' },
    { shortcut: 'D+8', label: 'Custom date' },
  ],
  '/expense': [
    { shortcut: 'N', label: 'New' },
    { shortcut: 'D+1-7', label: 'Date range' },
    { shortcut: 'D+8', label: 'Custom date' },
  ],
  '/sales': [
    { shortcut: 'N', label: 'New' },
    { shortcut: '[ ]', label: 'Switch tab' },
    { shortcut: 'D+1-7', label: 'Date range' },
    { shortcut: 'D+8', label: 'Custom date' },
  ],
  '/purchase': [
    { shortcut: 'N', label: 'New' },
    { shortcut: '[ ]', label: 'Switch tab' },
    { shortcut: 'D+1-7', label: 'Date range' },
  ],
  '/inventory': [
    { shortcut: 'N', label: 'New' },
    { shortcut: '[ ]', label: 'Switch tab' },
    { shortcut: '1-4', label: 'Category filter' },
    { shortcut: 'G+0-9', label: 'Group filter' },
  ],
  '/ledger': [
    { shortcut: 'N', label: 'New' },
    { shortcut: '[ ]', label: 'Switch tab' },
    { shortcut: 'F', label: 'Select ledger' },
    { shortcut: '↑↓', label: 'Navigate ledgers' },
    { shortcut: 'D+1-7', label: 'Date range' },
  ],
  '/recurring': [
    { shortcut: 'N', label: 'New' },
    { shortcut: '[ ]', label: 'Switch tab' },
  ],
  '/audit-trail': [
    { shortcut: 'C', label: 'Clear logs' },
  ],
  '/users': [],
  '/deleted-records': [],
  '/all-entries': [
    { shortcut: 'D 1-8', label: 'Date range' },
  ],
  '/dashboard': [],
};

export const ShortcutHints = () => {
  const location = useLocation();
  const { isAdmin } = useAuth();
  const path = location.pathname;

  const pageHints = PAGE_HINTS[path] || [];
  const isHomepage = path === '/';

  const hints = isHomepage
    ? [...pageHints, ...COMMON_HINTS.filter(h => h.shortcut === '?')]
    : [...pageHints, ...COMMON_HINTS];

  if (hints.length === 0) return null;

  return (
    <div className="hidden sm:flex fixed bottom-0 left-0 right-0 z-30 items-center justify-center gap-5 py-2.5 px-4 bg-muted/90 backdrop-blur-sm border-t border-border/50" data-testid="shortcut-hints">
      {hints.map((h, i) => (
        <Hint key={i} shortcut={h.shortcut} label={h.label} />
      ))}
    </div>
  );
};
